var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row link-contact" },
    [
      _c(
        "router-link",
        { staticClass: "link-contact__link", attrs: { to: _vm.toRoute } },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("company.contactTable.linkContact")) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "link-contact__plus" }, [_vm._v("+")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }